import React, { useState } from 'react';

import { useFetchNotesQuery } from '../../api/index';

export function NoteViewer() {
	const {
		data: note,
		isLoading,
		isSuccess,
		isError,
		error
	} = useFetchNotesQuery('arf')

	let content
	if (isLoading) {
		content = <div>Loading</div>
	} else if (isSuccess) {
		content = <div>Loading</div>
	} else if (isError) {
		content = <div>{error.toString()}</div>
	}
	return (
		<div>
			{content}
		</div>
	)
}

